import { Navigate, useParams, useSearchParams } from 'react-router-dom';

/**
 * RedirectToKatalog — uniwersalny redirector dla starych stron publicznych
 * (BreedPage, BreedsListPage, programmatic SEO routes).
 *
 * Ujednolica wszystkie publiczne strony marketplace pod jeden URL `/katalog`.
 * Bot traffic dla SEO landing pages jest obsługiwany niezależnie przez
 * Cloudflare Worker → /api/seo/render.
 *
 * Slug rasy/miasta/województwa jest przekazywany jako-jest do filtrów /katalog.
 * Backend regex (case-insensitive) na breed/city/voivodeship dopasowuje wartości.
 *
 * Props:
 *  type — 'mioty' | 'hodowle' | 'reproduktory' | null (= wszystkie)
 *  breedParam — nazwa parametru z URL np. 'breed', 'breedSlug'
 *  cityParam — nazwa parametru z URL np. 'city', 'citySlug'
 *  voivodeshipParam — nazwa parametru z URL np. 'voivodeship'
 */
export default function RedirectToKatalog({
  type = null,
  breedParam = null,
  cityParam = null,
  voivodeshipParam = null,
}) {
  const params = useParams();
  const [searchParams] = useSearchParams();

  const qs = new URLSearchParams();
  if (type) qs.set('type', type);

  if (breedParam && params[breedParam]) {
    qs.set('rasa', slugToReadable(params[breedParam]));
  }
  if (cityParam && params[cityParam]) {
    qs.set('miasto', slugToReadable(params[cityParam]));
  }
  if (voivodeshipParam && params[voivodeshipParam]) {
    qs.set('wojewodztwo', slugToReadable(params[voivodeshipParam]));
  }

  // Preserve any extra query params (utm_*, ref, etc.)
  for (const [k, v] of searchParams.entries()) {
    if (!qs.has(k)) qs.set(k, v);
  }

  return <Navigate to={`/katalog?${qs.toString()}`} replace />;
}

/**
 * Konwertuje slug typu "buldog-amerykanski" → "buldog amerykanski".
 * Backend matchuje regex case-insensitive więc dopasuje też "Buldog amerykański".
 */
function slugToReadable(slug) {
  if (!slug) return '';
  return decodeURIComponent(slug).replace(/-/g, ' ').replace(/_/g, ' ').trim();
}
